import { Order } from "src/app/types/orders/order";
import { ISemRushKeywords } from "src/app/types/semrush";

export interface BulkSiloContainerProps {
    handleClose?(): void;
    selectedRowsId: number[];
    openModal?: boolean;
}

export interface IData {
    id: number;
    url?: string | null;
    numberOfSilo: number;
    selectedKeywords?: string[];
    lastSelectedKeywords?: string[];
    lastNumberOfSilo?: number;
    allKeywords?: string[];
    userKeywords?: string;
    semrushKeywords?: ISemRushKeywords[] | false;
    semrushError?: null | string;
}

export function currentInformation(selectedOrderId: number, data: IData[], orders: Order[] | null) {
    const currentOrderIndex = orders ? orders.findIndex((el) => el.id === selectedOrderId) : -1;
    const currentOrder = orders && currentOrderIndex !== -1 ? orders[currentOrderIndex] : null;
    const currentOrderKeyword =
        currentOrder && currentOrder?.keywords && currentOrder.keywords.length > 0
            ? currentOrder.keywords[0]
            : null;

    const currentData = data.find((el) => el.id === selectedOrderId);
    const currentDataIndex = data.findIndex((el) => el.id === selectedOrderId);
    const hasOneOrMoreKeywords = data.find(
        (el) =>
            (el.selectedKeywords && el.selectedKeywords.length > 0) ||
            (el.userKeywords && el.userKeywords.length > 0)
    );

    return {
        currentOrder,
        currentOrderIndex,
        currentOrderKeyword,
        currentData,
        hasOneOrMoreKeywords,
        currentDataIndex,
    };
}
